import React, { useEffect } from "react";
import { useNavigate, useSearchParams } from "react-router-dom";
import { api } from "@/lib/api";
import { Button } from "@/components/ui/button";
import { Ban } from "lucide-react";

export default function PaymentCancel() {
  const [params] = useSearchParams();
  const bookingId = params.get("booking_id");
  const navigate = useNavigate();

  useEffect(() => {
    if (bookingId) {
      api.post(`/bookings/${bookingId}/cancel`).catch(() => {});
    }
  }, [bookingId]);

  return (
    <div className="max-w-lg mx-auto px-6 py-24 text-center" data-testid="payment-cancel-page">
      <Ban className="w-14 h-14 mx-auto text-neutral-400" />
      <h1 className="font-display font-black tracking-tighter text-4xl mt-6">Checkout cancelled</h1>
      <p className="text-neutral-600 mt-3">No charge was made and the time slot has been released. You can try again anytime.</p>
      <Button onClick={() => navigate("/search")} className="mt-8 bg-[#FF4500] hover:bg-[#E63E00] text-white rounded-full h-12 px-8">
        Back to spaces
      </Button>
    </div>
  );
}
